
















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'c-chip'
})
export default class Chip extends Vue {
  @Prop(String) icon: string | undefined
}
